module.exports = __webpack_public_path__ + "static/img/video.b0e11776.png";